export const openTab = (url: string) => {
  const link = document.createElement('a')
  link.href = url
  link.target = '_blank'
  document.body.appendChild(link)
  link.click()
  link.remove()
}

export const scrollToTop = () =>
  document.getElementById('page')?.scrollTo({ top: 0, behavior: 'smooth' })

export const ECOM_ORDER_STATUS = {
  NEW: 'NEW',
  AWAITING_APPROVAL: 'AWAITING_APPROVAL',
  ACCEPTED: 'ACCEPTED',
  ORDER_CONFIRMED: 'ORDER_CONFIRMED',
  DELIVERED: 'DELIVERED',
  REJECTED: 'REJECTED',
  CANCELED: 'CANCELED',
  ASSET_MIGRATION: 'ASSET_MIGRATION',
}

export const isEcomOrderOpen = (status: keyof typeof ECOM_ORDER_STATUS) =>
  [
    ECOM_ORDER_STATUS.NEW,
    ECOM_ORDER_STATUS.AWAITING_APPROVAL,
    ECOM_ORDER_STATUS.ACCEPTED,
    ECOM_ORDER_STATUS.ORDER_CONFIRMED,
  ].includes(status)

export const isEcomMigrationOrder = (status: keyof typeof ECOM_ORDER_STATUS) =>
  [ECOM_ORDER_STATUS.ASSET_MIGRATION].includes(status)
